import AbstractVideo from "video/AbstractVideo";

class VideoHelper {
    /**
     * Get video player from video json object
     *
     * @param {object} data
     * @param {jQuery} $element
     * @param {object} settings
     *
     * @return {AbstractVideo}
     */
    static process_json(data, $element, settings = {}) {
        let provider_id = data.provider.id;

        if ('undefined' === typeof VideoHelper.providers[provider_id]) throw Error("Invalid video provider id: " + provider_id);

        return new VideoHelper.providers[provider_id](data, $element, settings);
    }

    static process(provider, id, $element, settings = {}) {
        return VideoHelper.process_json({provider: {id: provider}, customData: {id: id}}, $element, settings);
    }

    static register(provider_id, video) {
        VideoHelper.providers[provider_id] = video;
    }

    static get_video_details(url, provider = null) {
        if (provider === null) provider = this.get_video_provider_details(url);
        let promise;
        if (provider === null) {
            promise = Promise.reject("Unknown video url");
        } else {
            switch (provider.provider) {
                case VideoHelper.PROVIDER_YOUTUBE:
                    let videoId = provider.id;

                    promise = new Promise((resolve, reject) => {
                        $.ajax({
                            url: "https://www.googleapis.com/youtube/v3/videos",
                            data: {
                                id: videoId,
                                key: window.CONFIG.gallery.youtubeKey,
                                fields: "items(snippet(title,thumbnails(maxres,high)),contentDetails(duration))",
                                part: "snippet,contentDetails"
                            },
                            dataType: "json"
                        }).done((data) => {
                            if (data.items.length !== 1) {
                                reject('Unknown video')
                            } else {
                                resolve({
                                    id: videoId,
                                    name: data.items[0].snippet.title,
                                    duration: data.items[0].contentDetails.duration.replace(/[PTS]/g, "").replace(/[^0-9]/g, ":"),
                                    image: data.items[0].snippet.thumbnails.maxres ? data.items[0].snippet.thumbnails.maxres.url : data.items[0].snippet.thumbnails.high.url,
                                    provider: provider.displayUrl
                                });
                            }
                        }).fail(() => {
                            reject("Connection error");
                        });
                    });
                    break;
                case VideoHelper.PROVIDER_VIMEO:
                    promise = new Promise((resolve, reject) => {
                        this.updatePreviewAjax = $.ajax({
                            url: "https://api.vimeo.com/videos/" + provider.id,
                            headers: {
                                Authorization: "Bearer " + window.CONFIG.gallery.vimeoKey
                            },
                            dataType: "json"
                        }).done((data) => {
                            resolve({
                                id: videoId,
                                name: data.name,
                                duration: ValueHelper.format_time(data.duration),
                                image: data.pictures.sizes[4].link,
                                provider: provider.displayUrl
                            });
                        }).fail(function (jqXHR, textStatus, errorThrown) {
                            reject(errorThrown === "Not Found" ? "Invalid video url" : "Connection error");
                        });
                    });

                    break;
                default:
                    promise = Promise.reject("Unknown video provider");
                    break;
            }
        }

        return promise;
    }

    static get_video_provider_details(url) {
        let result = null;
        $.each(VideoHelper.PROVIDERS, (id, providerData) => {
            if (result !== null) return;
            let regexResult = providerData.url.exec(url);
            if (regexResult !== null) {
                result = {
                    provider: parseInt(id),
                    id: regexResult[1],
                    displayUrl: providerData.displayUrl
                };
            }
        });

        return result;
    }

}

VideoHelper.PROVIDER_YOUTUBE = 1;
VideoHelper.PROVIDER_VIMEO = 2;

VideoHelper.PROVIDERS = {
    [VideoHelper.PROVIDER_YOUTUBE]: {
        url: /(?:youtube\.com\/\S*(?:(?:\/e(?:mbed))?\/|watch\/?\?(?:\S*?&?v\=))|youtu\.be\/)([a-zA-Z0-9_-]{6,11})/,
        displayUrl: "youtube.com"
    },
    [VideoHelper.PROVIDER_VIMEO]: {
        url: /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^\/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/,
        displayUrl: "vimeo.com"
    }
};

VideoHelper.providers = {};

export default VideoHelper;
